(() => {
  if (window.__bhaktiMainProductFirstCartPatchV1) return;
  window.__bhaktiMainProductFirstCartPatchV1 = true;

  const originalFetch = window.fetch.bind(window);
  const isFreeGift = (item) =>
    String(item?.properties?._bhakti_free_gift || '').toLowerCase() === 'true';

  window.fetch = (input, init) => {
    try {
      const url = typeof input === 'string' ? input : (input?.url || '');
      const body = init?.body;
      const isCartAdd = /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(url);

      if (isCartAdd && typeof body === 'string') {
        const payload = JSON.parse(body);
        if (Array.isArray(payload?.items) && payload.items.length > 1) {
          const giftItems = payload.items.filter(isFreeGift);
          const paidItems = payload.items.filter((item) => !isFreeGift(item));

          if (giftItems.length && paidItems.length) {
            // This store returns newly added batch lines in reverse cart/order order.
            // Send gifts first and paid items reversed so the paid product stays first
            // in the final order, allowing WhatsApp to use its product/hero image.
            payload.items = [...giftItems, ...paidItems.reverse()];
            init = { ...init, body: JSON.stringify(payload) };
          }
        }
      }
    } catch (error) {
      console.warn('[Bhakthination] Main-product-first cart patch skipped.', error);
    }

    return originalFetch(input, init);
  };

  const currentScript = document.currentScript;
  if (currentScript?.src && !document.querySelector('script[data-bhakti-divine-cro-core]')) {
    const coreSrc = currentScript.src.replace(
      /bhakti-divine-cro\.js(?=\?|$)/,
      'bhakti-divine-cro-core.js'
    );

    if (coreSrc !== currentScript.src) {
      const coreScript = document.createElement('script');
      coreScript.src = coreSrc;
      coreScript.async = false;
      coreScript.dataset.bhaktiDivineCroCore = 'true';
      currentScript.after(coreScript);
    }
  }
})();

(() => {
  const currentScript = document.currentScript;
  if (!currentScript?.src || document.querySelector('script[data-bhakti-verified-reviews-loader]')) return;
  const reviewsSrc = currentScript.src.replace(
    /bhakti-divine-cro\.js(?=\?|$)/,
    'bhakti-verified-reviews.js'
  );
  if (reviewsSrc === currentScript.src) return;
  const reviewsScript = document.createElement('script');
  reviewsScript.src = reviewsSrc;
  reviewsScript.async = false;
  reviewsScript.dataset.bhaktiVerifiedReviewsLoader = 'true';
  currentScript.after(reviewsScript);
})();
